import React from "react";
import ConsultationForm from "./ConsultationForm";
import "../../styles/FinalSection.css";


const SOCIALS = (
<svg xmlns="http://www.w3.org/2000/svg" width="176" height="24" viewBox="0 0 176 24" fill="none">
  <path d="M88.5747 18.2739H90.124C90.124 18.2739 90.5924 18.2229 90.8306 17.9696C91.051 17.737 91.0429 17.3004 91.0429 17.3004C91.0429 17.3004 91.0121 15.2561 91.978 14.9549C92.9293 14.6586 94.1513 16.9307 95.4462 17.8055C96.4251 18.4667 97.1689 18.3217 97.1689 18.3217L100.632 18.2739C100.632 18.2739 102.444 18.164 101.585 16.7634C101.515 16.6487 101.084 15.7277 99.01 13.8348C96.8383 11.8526 97.13 12.1745 99.7458 8.74716C101.339 6.65984 101.976 5.38514 101.776 4.84021C101.587 4.32077 100.415 4.4578 100.415 4.4578L96.5191 4.4801C96.5191 4.4801 96.2306 4.44186 96.015 4.56774C95.806 4.69202 95.6715 4.97883 95.6715 4.97883C95.6715 4.97883 95.054 6.59451 94.2307 7.968C92.495 10.8663 91.7998 11.0193 91.5161 10.8393C90.8565 10.4202 91.0218 9.15347 91.0218 8.25481C91.0218 5.44569 91.4546 4.27456 90.1775 3.97182C89.7529 3.87144 89.4417 3.80451 88.3575 3.79336C86.967 3.77902 85.7888 3.79814 85.1227 4.11841C84.6787 4.33192 84.3367 4.80834 84.5458 4.83543C84.8034 4.86889 85.3869 4.98998 85.6964 5.40426C86.0967 5.93804 86.0821 7.13944 86.0821 7.13944C86.0821 7.13944 86.3123 10.4457 85.5457 10.8568C85.019 11.1388 84.2978 10.5636 82.7501 7.93294C81.9576 6.58654 81.358 5.09674 81.358 5.09674C81.358 5.09674 81.2429 4.81949 81.0371 4.67131C80.7875 4.49126 80.4374 4.4339 80.4374 4.4339L76.7327 4.4562C76.7327 4.4562 76.1768 4.47214 75.9726 4.70955C75.7911 4.92147 75.958 5.35805 75.958 5.35805C75.958 5.35805 78.8589 12.0295 82.1424 15.3931C85.1551 18.4763 88.5747 18.2739 88.5747 18.2739Z" fill="#323232"/>
  <path d="M17.8035 2.32798C16.1644 2.92143 0.734747 9.61893 0.367373 9.92979C0.169557 10.0711 0 10.6363 0 11.1449C0 12.2471 0.678228 12.784 3.39114 13.8013L5.00193 14.3948L5.7932 16.9381C6.89532 20.4706 7.51703 20.7532 9.77779 18.775L11.219 17.5033L12.8863 19.1989C14.3276 20.6401 14.6667 20.8662 15.5992 20.8662C16.3905 20.8662 16.7579 20.6967 17.0687 20.2162C17.5209 19.538 20.3468 5.43653 20.3468 3.85399C20.3468 2.35624 19.386 1.79105 17.8035 2.32798ZM17.0687 11.2862C16.334 15.073 15.6275 18.2946 15.5145 18.4359C15.4014 18.5772 14.4123 17.8424 13.3385 16.7968C12.2646 15.7795 11.3038 14.9317 11.219 14.9317C11.106 14.9317 10.5125 15.3839 9.89082 15.9491C8.70392 17.0229 8.56263 16.9099 9.04304 15.1861C9.24086 14.4513 10.2865 13.1514 12.4342 10.8906C14.158 9.11026 15.5427 7.55599 15.5427 7.47121C15.5427 6.9908 14.3276 7.55599 10.2582 9.92979L5.7932 12.5862L4.38022 12.021C3.61722 11.7101 2.88247 11.371 2.74117 11.258C2.57161 11.0884 18.0861 4.19311 18.3122 4.33441C18.3687 4.39092 17.8035 7.49947 17.0687 11.2862Z" fill="#323232"/>
  <path d="M163.282 0.0902672C161.245 0.230467 159.28 0.897078 157.584 2.02397C156.346 2.84665 155.169 4.0238 154.346 5.26179C153.325 6.80135 152.69 8.534 152.458 10.4174C152.391 10.965 152.391 12.5152 152.458 13.0627C152.791 15.7556 153.942 18.1311 155.82 20.0013C157.703 21.8768 160.057 23.0143 162.74 23.3449C163.287 23.4111 164.837 23.4111 165.385 23.3449C168.067 23.0143 170.43 21.8715 172.31 19.996C174.107 18.2052 175.252 15.9196 175.62 13.3934C175.704 12.8088 175.715 12.6289 175.715 11.6872C175.712 11.0073 175.702 10.7111 175.665 10.4174C175.339 7.73777 174.181 5.34644 172.302 3.47358C170.44 1.61659 168.065 0.465899 165.411 0.140528C165.076 0.0982037 163.652 0.0664597 163.282 0.0902672ZM169.821 6.6003C170.721 6.84367 171.324 7.50764 171.482 8.43348C171.519 8.63188 171.522 9.10274 171.514 11.875C171.506 15.4303 171.519 15.171 171.332 15.6234C171.213 15.917 171.049 16.1498 170.792 16.3931C170.506 16.663 170.165 16.8428 169.763 16.9275L169.498 16.9857L164.203 16.9963C160.563 17.0042 158.817 16.9989 158.626 16.9804C157.796 16.8957 157.079 16.3799 156.761 15.6339C156.582 15.2107 156.592 15.4541 156.587 11.8591C156.579 8.2536 156.574 8.39645 156.751 7.94675C156.931 7.49176 157.23 7.12936 157.616 6.88864C157.88 6.72463 158.063 6.65056 158.375 6.58443C158.621 6.53417 158.716 6.53153 164.115 6.53682L169.604 6.54211L169.821 6.6003Z" fill="#323232"/>
  <path d="M162.576 11.4771C162.57 13.3817 162.576 14.252 162.594 14.2441C162.61 14.2388 162.909 14.0457 163.256 13.8156C164.139 13.2336 165.671 12.2257 166.276 11.8263C166.557 11.6411 166.787 11.4824 166.787 11.4745C166.787 11.4665 166.671 11.3845 166.53 11.292C166.388 11.1994 165.903 10.8793 165.451 10.5804C163.618 9.37148 162.713 8.77629 162.615 8.71545C162.589 8.69958 162.581 9.27096 162.576 11.4771Z" fill="#323232"/>
</svg>
)

const FinalSection = () => {
  const handleScrollToForm = () => {
    const formElement = document.getElementById("contact-form");
    if (formElement) {
      const yOffset = -80; // отступ сверху (в пикселях), подстрой по нуждам
      const y = formElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section className="final-section">
      <div className="final-container">
        <div className="final-contacts">
          <span className="final-title">ABTOSALES</span>

          <div className="final-buttons">
          <button
            className="final-button"
            onClick={() => {
              const element = document.getElementById('contacts');
              if (element) {
                const offset = -100; // Поднять на 100px выше
                const y = element.getBoundingClientRect().top + window.pageYOffset + offset;

                window.scrollTo({ top: y, behavior: 'smooth' });
              }
            }}
          >
            Позвонить
          </button>

          <button
            className="final-button"
            onClick={() => window.open('https://t.me/autosalesrnd', '_blank')}
          >
            Написать
          </button>
            {/* <button className="final-button" onClick={handleScrollToForm}>Обратный звонок</button> */}
          </div>
        </div>
          <div id="contact-form">
          {/* <ConsultationForm /> */}
          </div>

        <div className="final-info">
          <div className="final-adress">
            <span className="final-adress-text">Ростов-на-Дону,</span>
            <span className="final-adress-text">пер. Энергетиков 1а/5,</span>
            <span className="final-adress-text">ТК «Рубин», павильон 21/2</span>
          </div>

          {/* <div className="final-phones">
            <span className="final-phones-text">+7 (903) 407-55-00</span>
            <span className="final-phones-text">+7 (961) 290-09-08</span>
            <span className="final-phones-text third-number">+7 (961) 328-70-75</span>
          </div> */}

          <div className="final-socials">
            <a href="https://t.me/autosalesrnd" target="_blank" rel="noopener noreferrer">
              {SOCIALS}
            </a>
          </div>

          {/* <div className="final-links">
            <a href="/privacy-policy" className="final-link">Политика конфиденциальности</a>
            <a href="/public-offer" className="final-link">Публичная оферта</a>
          </div> */}
        </div>
      </div>
    </section>
  )
}

export default FinalSection;
